const base = {
  'c.HeadTooBar.slogan': 'Качественные запчасти, глобальные закупки в одном месте',
  'c.HeadTooBar.modifyPassword': 'Изменить пароль',
  'c.HeadTooBar.logout': 'Выйти',
  'c.HeadTooBar.signUp': 'Регистрация',
  'c.HeadTooBar.login': 'Войти',
  'c.HeadTooBar.helpCenter': 'Центр помощи',

  'base.button.login': 'Войти',
  'base.button.ok': 'Ладно',
  'base.message.pleaseLogin': 'Доступно после входа',

  'base.language': 'Язык',
  'base.countryorregion': 'Страна/Регион',
  'base.currency': 'Валюта',
  'base.currency.placeholder': 'Выберите валюту',

  'base.noData': 'Нет данных',
  'base.OE': 'OE',

  'menu.home': 'Главная',
  'menu.product': 'Каталог запчастей',
  copyright:
    'Copyright © 2015–настоящее время CassTime. Все права защищены: Шэньчжэнь КассТайм Технолоджи Ко., Лтд.',

  'home.vehicleBrandTitle': 'Особенности запчастей {vehicleBrand}',
  'home.AccessoriesClassification': 'Классификация запчастей',
  'home.comingSoon': 'Скоро',

  'productList.total': 'Найдено {total} результатов для вас',
  'productList.priceTips':
    '*Отображаемая цена является справочной ценой EXW, фактическая цена может варьироваться в зависимости от количества заказа',
  'productList.loginToView': 'Войдите, чтобы просмотреть',
  'productList.circulationRating': 'Рейтинг обращения',
  'productList.filter.oe.placeholder': 'Номер OE или название запчасти',
  'productList.contactUs': 'Связаться с нами',
  'productList.addToList': 'Добавить в список',
  'productList.removeList': 'Удалить из списка',
  'productList.contactUs.web': 'Веб-версия',
  'productList.contactUs.template': 'Здравствуйте, я хотел бы узнать об этом продукте:',
  'productList.applicableVehicleTypes': 'Применимые модели',
  'productList.approximately': 'Примерно',

  'pagination.total': 'Всего {total} записей',

  'base.message.apiError': 'Система занята! Пожалуйста, повторите попытку позже.',

  'base.remark': 'Примечание',
  'base.remark.placeholder': 'Введите примечание',
  'base.remark.maxLength': 'Примечание не может превышать {total} символов',

  'base.copy': 'Копировать',
  'base.copied': 'Скопировано',

  'page.title.addressList': 'Управление адресами',
  'page.title.orderList': 'Управление заказами',
  'page.title.orderDetails': 'Детали заказа',
  'page.title.orderConfirmation': 'Подтверждение заказа',

  'base.noLogin.getInfoError':
    'Не удалось получить информацию пользователя. Пожалуйста, обновите страницу и попробуйте снова',
  'base.api.error': 'Система занята! Пожалуйста, повторите попытку позже.',

  'base.creator': 'Создатель',
  'base.createdDate': 'Дата создания',
  'base.operation': 'Операция',
  'base.detail': 'Детали',

  'base.attachment': 'Вложение',
  'base.form.checkForm': 'Пожалуйста, проверьте содержимое формы',
  'base.index': 'Порядковый номер',
  'base.status': 'Статус',
  'base.quantity': 'Количество',

  'base.HeadTooBar.getUserInfoFailed':
    'Не удалось получить информацию пользователя. Пожалуйста, обновите страницу и попробуйте снова',

  Search: 'Поиск',
  Action: 'Действие',
  Delivery: 'Доставка',
  total_days: '{total} дней',
  Item: 'Товар',
  Price_currency: 'Цена ({currency})',

  total_Parts: '{total} запчастей',
  total_parts: '{total} запчастей',
  Show_all: 'Показать все',
  Collapse: 'Свернуть',
  Part_name: 'Название запчасти',
  Brand: 'Бренд',
  Part_number: 'Номер запчасти',
  Description: 'Описание',
  loading: 'загрузка...',
};

export default base;
